module.exports = __webpack_public_path__ + "img/2012-12-14 20.05.18.bb3286b6.jpg";